__turbopack_context__.v({
  "offerHistoryContainer": "styles-module__0w-w_W__offerHistoryContainer",
  "offerHistoryProgressBarContainer": "styles-module__0w-w_W__offerHistoryProgressBarContainer",
  "offerHistoryValues": "styles-module__0w-w_W__offerHistoryValues",
  "offerHistoryValuesCaption": "styles-module__0w-w_W__offerHistoryValuesCaption",
  "offerHistoryValuesContainer": "styles-module__0w-w_W__offerHistoryValuesContainer",
});
